export const maxHeight = '800px';
export const maxValueScale = 1.2;
